module.exports = __webpack_public_path__ + "static/media/TW.9996bad6.svg";